import React from 'react';
import { useParams } from 'react-router-dom';
import SquidTrench from '../pages/SquidTrench';
import WorldDetail from '../pages/WorldDetail';

// WorldRouter - routes to specific world components based on worldId
const WorldRouter = () => {
  const { worldId } = useParams();
  
  // Debug log
  console.log('WorldRouter - worldId:', worldId);
  
  // Route to specific world components
  if (worldId === 'squidtrench') {
    console.log('WorldRouter - rendering SquidTrench');
    return <SquidTrench />;
  }
  
  console.log('WorldRouter - rendering WorldDetail');
  // Default to WorldDetail for other worlds
  return <WorldDetail />;
};

export default WorldRouter;
